import * as React from 'react';

import { CustomUI, TokenGrantType } from '@ul/appsetting-model';

export interface AppSettingContextData {
    feature: {
        emailLogin?: {
            usernameRegex?: string;
            passwordRegex?: string;
            thirdPartyAuth?: boolean;
        };
        phoneLogin?: {
            passwordRegex?: string;
        };
        emailResetPassword?: {
            resetPasswordRedirect?: boolean;
            resetPasswordUrl?: string;
        };
        phoneResetPassword?: {
            resetPasswordRedirect?: boolean;
            resetPasswordUrl?: string;
        };
        facebookLogin?: {
            appId: string;
        };
        googleLogin?: {
            clientId: string;
        };
        appleLogin?: {
            clientId: string;
        };
        signup?: {
            signupRedirect?: boolean;
            signupUrl?: string;
            emailSignup?: boolean;
            phoneSignup?: boolean;
            emailMarketingSubscription?: boolean;
        };
        weChatLogin?: {
            appId: string;
            domain: string;
        };
        userSessionManagement?: {
            refreshGapInSec?: number | null;
            forceLogoutEnable?: boolean | null;
            excludedPageTypeIds?: Array<number>;
            tokenExpiryInSec?: number | null;
            onPromptTimeInSec?: number | null;
            intervalTimeInSec?: number | null;
            idleThresholdInSec?: number | null;
            logoutUrl?: string | null;
        };
        kakaoLogin?: {
            appKey: string;
        };
        lineLogin?: {
            clientId: string;
        };
        kakaoTalkLogin?: {};
        l1Login?: {};
        googleAppLogin?: {};
        weChatAppLogin?: {};
        facebookAppLogin?: {};
        lineAppLogin?: {};
        otpLogin?: boolean;
        whatsAppLogin?: boolean;
        useNewPhoneValidation?: boolean;
        signInCallBack?: boolean;
        signInWithOtp?: boolean;
        passwordLoginOption?: boolean;
        passkeyAuthentication?: boolean;
    };
    customUI?: CustomUI;
    tokenGrantType?: TokenGrantType;
}

export const defaultAppSetting = {
    feature: {},
};

export const AppSettingContext = React.createContext<AppSettingContextData>(defaultAppSetting);
AppSettingContext.displayName = 'AppSettingContext';
